export default "__VITE_ASSET__f83b5900__"